export const TITLE = 'Tekst';
export const PLACEHOLDER = 'Tilføj tekst...';
export const DELETE_TEXT = 'Slet tekst';